import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, Route, Routes } from "react-router-dom";

import { getUserProfile } from "@/apis";
import { getQueryParams } from "@/lib/utils";
import useGlobalStore from "@/stores/useGlobalStore";
import AccessDenied from "@/components/AccessDenied";

import ChatLayout from "./ChatLayout";
import ReminderList from "../reminder/list/index.jsx";
import ReminderDetail from "../reminder/detail/index.jsx";

const routes = [
  {
    path: "/",
    element: <ChatLayout />,
  },
  {
    path: "/chat/:chatId",
    element: <ChatLayout />,
  },
  {
    path: "/reminder",
    element: <ReminderList />,
  },
  {
    path: "/reminder/:reminderId",
    element: <ReminderDetail />,
  },
];

let router = createBrowserRouter(routes);

function App() {
  const [isAllowed, setIsAllowed] = useState();

  useEffect(() => {
    const businessFromParam = getQueryParams("business");
    const currentBusiness = sessionStorage.getItem("business");
    const businessCode = businessFromParam || currentBusiness;

    const managerAccessToken = getQueryParams("manager_access_token");
    if (managerAccessToken) {
      sessionStorage.setItem("manager_access_token", managerAccessToken);
    }
    const sessionToken = getQueryParams("session_token");
    if (sessionToken) {
      sessionStorage.setItem("session_token", sessionToken);
    }

    getUserProfile(businessCode).then((profile) => {
      const { acceptMenus = [], business, ...rest } = profile || {};
      useGlobalStore.setState({ user: rest, availableBusinesses: business });
      if (acceptMenus?.includes("/ai-chatbot")) {
        setIsAllowed(true);
      } else {
        setIsAllowed(false);
      }

      if (businessCode) {
        sessionStorage.setItem("business", businessCode);
        useGlobalStore.setState({ business: businessCode });
        return;
      }

      if (business?.[0]?.code) {
        sessionStorage.setItem("business", business?.[0]?.code);
        useGlobalStore.setState({ business: business?.[0]?.code });
      }
    });
  }, []);

  if (isAllowed === undefined) {
    return null;
  }

  if (!isAllowed) {
    return <AccessDenied />;
  }

  return <RouterProvider router={router} />;
}

export default App;
